



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { MetaService } from '@/shared/services/meta-service'
import { PasswordModel } from '@/shared/models/password-model'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { Injector } from '@/config/dependency-injection'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { CHANGE_PASSWORD } from '@/business/account/store/types'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import { Form } from '@/shared/forms/form'
import { OrganisationSecurityForm } from '@/business/organisation/models/organisation-security-form'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import { AccountModule } from '@/business/account/store/account-module'
import { NotificationService } from '@/shared/services/notification-service'
import { ChangePassword } from '@/api/generated'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  components: {
    UnifyButton,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoValidationFeedback,
    RespondecoForm,
  },
  data() {
    return {
      form: new Form<ChangePassword, OrganisationSecurityForm>(OrganisationSecurityForm, this),
    }
  },
})
export default class OrganisationSettingsSecurity extends Vue {
  public form!: Form<ChangePassword, OrganisationSecurityForm>
  public password: PasswordModel = new PasswordModel()

  private accountModule = Injector.get(AccountModule)
  private loaderHelper = Injector.get(LoaderHelper)
  private metaService: MetaService = Injector.get(MetaService)
  private notificationService = Injector.get(NotificationService)
  private organisationsModule: OrganisationsModule = Injector.get(OrganisationsModule)

  get isLoading() {
    return this.loaderHelper.isLoading(CHANGE_PASSWORD)
  }

  public created() {
    this.metaService.updateDocumentTitle('organisation.settings.security', {
      name: this.organisationsModule.organisationViewModel.organisation.name,
    })
  }

  public reset() {
    this.form.reset()
  }

  public save() {
    this.accountModule
      .changePassword({
        newPassword: this.form.value.newPassword,
        oldPassword: this.form.value.oldPassword,
      })
      .then(
        this.notificationService.successHandler('account.password_change.initiated'),
        this.notificationService.errorHandler({
          400: this.$t('account.invalid_password'),
        })
      )
  }

  public validations() {
    return this.form.validations()
  }
}
